import { getContent, getOrder } from '@vue/services/api/checkout.api'
import { deleteBearerToken } from '@vue/services/jwt.service'
import { getProfile } from '@vue/services/api/profile.api';

import {
  SET_ADDRESS_MODAL,
  SET_AML_MODAL,
  SET_VELOCITY_MODAL,
  SET_ADDRESS_STRING,
  SET_ORDER,
  EXPIRED_ORDER,
  SET_IS_SIGNED_IN_TO_LOYALTY
} from '@vue/common/constants/mutation.types'
import { actionTypes } from '@vue/common/constants/store.types'
const initialState = {
  steps: {
    review: false,
    delivery: false,
    information: false,
    finalReview: false,
    payment: false,
    confirmation: false
  },
  content: null,
  order: null,
  amlModal: false,
  velocityModal: false,
  addressModal: false,
  addressString: null,
  isSignedInToLoyalty: false
}

const state = { ...initialState }

const actions = {
  async init({ dispatch }) {
    await dispatch('setSignInStatus');
  },  
  async [actionTypes.GetCheckoutContent]({ state }) {
    const { data } = await getContent()
    state.content = data
  },
  [actionTypes.AbandonCheckout]({ state, dispatch }) {
    deleteBearerToken()

    return new Promise(resolve => {
      state.order
        ? (state.order = null)
        : dispatch('cart/abandonCart', null, { root: true })

      resolve()
    })
  },
  [actionTypes.GetOrder]({ commit }) {
    return getOrder().then(({data}) => commit(SET_ORDER, data));
  },
  async setSignInStatus({ commit }) {
    try {
      await getProfile();
      commit(SET_IS_SIGNED_IN_TO_LOYALTY, true);
    }
    catch(ex) {
      commit(SET_IS_SIGNED_IN_TO_LOYALTY, false);
    }
  }
}

const mutations = {
  [SET_ADDRESS_MODAL](state, flag) {
    state.addressModal = flag
  },
  [SET_AML_MODAL](state, flag) {
    state.amlModal = flag
  },
  [SET_VELOCITY_MODAL](state, flag) {
    state.velocityModal = flag
  },
  updateStep(state, step) {
    for (const key in state.steps) {
      state.steps[key] = false
    }

    state.steps[step] = true
  },
  [SET_ADDRESS_STRING](state, addressString) {
    state.addressString = addressString
  },
  [SET_ORDER](state, data) {
    state.order = data;
  },

  [EXPIRED_ORDER](state) {
    state.order = null
  },
  [SET_IS_SIGNED_IN_TO_LOYALTY](state, isSignedInToLoyalty) {
    state.isSignedInToLoyalty = isSignedInToLoyalty
  }
}

const getters = {}

const checkout = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export default checkout
